import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { serviceCostModel } from '.';
export var StagesValueType = /*#__PURE__*/ function(StagesValueType) {
    StagesValueType["Percent"] = "percent";
    StagesValueType["Amount"] = "amount";
    return StagesValueType;
}({});
export var StagesTerms = /*#__PURE__*/ function(StagesTerms) {
    StagesTerms["AutoFirst"] = "auto_first";
    StagesTerms["AllManual"] = "all_manual";
    return StagesTerms;
}({});
export var BillingStageScheduleType = /*#__PURE__*/ function(BillingStageScheduleType) {
    BillingStageScheduleType["OnEffectiveDate"] = "onEffectiveDate";
    BillingStageScheduleType["RelativeToEffectiveDate"] = "relativeToEffectiveDate";
    BillingStageScheduleType["OnDate"] = "onDate";
    BillingStageScheduleType["Manual"] = "manual";
    BillingStageScheduleType["RequiresDateSelection"] = "requiresDateSelection";
    return BillingStageScheduleType;
}({});
export var StageScheduleContext = /*#__PURE__*/ function(StageScheduleContext) {
    StageScheduleContext["ProposalOnAcceptance"] = "proposal-on-acceptance";
    StageScheduleContext["ProposalOnEffectiveDate"] = "proposal-on-effective-date";
    StageScheduleContext["Amendment"] = "amendment";
    StageScheduleContext["Template"] = "template";
    return StageScheduleContext;
}({});
export var StageScheduleValidationError = /*#__PURE__*/ function(StageScheduleValidationError) {
    StageScheduleValidationError["SetDate"] = "setDate";
    StageScheduleValidationError["DateBeforeEffectiveDate"] = "dateBeforeEffectiveDate";
    StageScheduleValidationError["DaysRequired"] = "daysRequired";
    StageScheduleValidationError["DaysAtLeastOne"] = "daysAtLeastOne";
    return StageScheduleValidationError;
}({});
const scheduleFromDTO = (dto)=>{
    if (!dto) return undefined;
    switch(dto.type){
        case "onEffectiveDate":
            return {
                type: "onEffectiveDate"
            };
        case "manual":
            return {
                type: "manual"
            };
        case "requiresDateSelection":
            return {
                type: "requiresDateSelection"
            };
        case "relativeToEffectiveDate":
            var _dto_relativeToEffectiveDate;
            return {
                type: "relativeToEffectiveDate",
                relativeToEffectiveDate: (_dto_relativeToEffectiveDate = dto.relativeToEffectiveDate) !== null && _dto_relativeToEffectiveDate !== void 0 ? _dto_relativeToEffectiveDate : {
                    days: 0
                }
            };
        case "onDate":
            var _dto_onDate;
            return {
                type: "onDate",
                onDate: (_dto_onDate = dto.onDate) !== null && _dto_onDate !== void 0 ? _dto_onDate : {
                    date: ''
                }
            };
    }
};
const validateRelativeDays = (days)=>{
    if (days === 0) return "daysRequired";
    if (days < 0) return "daysAtLeastOne";
    return null;
};
const validateOnDate = (params)=>{
    const { date, context, effectiveDate, today } = params;
    if (!date) return "setDate";
    if (context === "amendment" && date < today) {
        return "setDate";
    }
    if (context === "proposal-on-effective-date" && effectiveDate && date < effectiveDate) {
        return "dateBeforeEffectiveDate";
    }
    return null;
};
const scheduleToDTO = (schedule)=>{
    if (!schedule) return undefined;
    switch(schedule.type){
        case "onEffectiveDate":
        case "manual":
        case "requiresDateSelection":
            return {
                type: schedule.type
            };
        case "relativeToEffectiveDate":
            return {
                type: schedule.type,
                relativeToEffectiveDate: schedule.relativeToEffectiveDate
            };
        case "onDate":
            return {
                type: schedule.type,
                onDate: schedule.onDate
            };
    }
};
export class OneTimeInStagesModel {
    static fromDTO(dto) {
        return new OneTimeInStagesModel({
            valueType: dto.valueType,
            terms: dto.terms,
            stages: dto.stages.map((stage)=>({
                    stageNumber: stage.stageNumber,
                    value: new Decimal(stage.value).div(100),
                    schedule: scheduleFromDTO(stage.schedule)
                }))
        });
    }
    static defaultStageSchedule() {
        return {
            type: "manual"
        };
    }
    static isStageScheduleValid(params) {
        const { schedule, context, effectiveDate, today } = params;
        if (!schedule) return null;
        switch(schedule.type){
            case "onEffectiveDate":
            case "manual":
                return null;
            case "requiresDateSelection":
                return context === "template" ? null : "setDate";
            case "relativeToEffectiveDate":
                return validateRelativeDays(schedule.relativeToEffectiveDate.days);
            case "onDate":
                return validateOnDate({
                    date: schedule.onDate.date,
                    context,
                    effectiveDate,
                    today
                });
        }
    }
    static forSaveAsTemplate(params) {
        const { stages, today } = params;
        return stages.map((stage)=>{
            const schedule = stage.schedule;
            if (schedule && schedule.type === "onDate" && schedule.onDate.date && schedule.onDate.date < today) {
                return _object_spread_props(_object_spread({}, stage), {
                    schedule: {
                        type: "requiresDateSelection"
                    }
                });
            }
            return stage;
        });
    }
    static make(data) {
        return new OneTimeInStagesModel(data);
    }
    static makeStage(stageNumber, value) {
        return {
            stageNumber,
            value
        };
    }
    toDTO() {
        return {
            valueType: this.data.valueType,
            terms: this.data.terms,
            stages: this.data.stages.map((stage)=>({
                    stageNumber: stage.stageNumber,
                    value: stage.value.mul(100).toNumber(),
                    schedule: scheduleToDTO(stage.schedule)
                }))
        };
    }
    withStageSchedule(index, schedule) {
        const stages = this.data.stages.map((stage, i)=>i === index ? _object_spread_props(_object_spread({}, stage), {
                schedule
            }) : stage);
        return new OneTimeInStagesModel(_object_spread_props(_object_spread({}, this.data), {
            stages
        }));
    }
    numStages() {
        return this.data.stages.length;
    }
    hasInvalidStages(cost) {
        const stages = this.data.stages;
        if (stages.length === 0) return false;
        const valueType = this.data.valueType;
        const isPercentage = valueType === "percent";
        if (stages.some((s)=>s.value.lte(0) || isPercentage && s.value.gte(100))) return true;
        if (cost) {
            const totalRate = serviceCostModel.price(cost);
            const isValueTypeDollars = valueType === "amount";
            const totalSum = stages.reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0));
            const totalSumExceedsRate = totalSum.gt(isValueTypeDollars ? totalRate : new Decimal(100));
            return stages.some((stage, index)=>{
                const isLast = index === stages.length - 1;
                if (valueType === "percent" && stage.value.gte(100)) return true;
                if (isValueTypeDollars && stage.value.gt(totalRate)) return true;
                if (valueType === "percent" && !isLast && totalSumExceedsRate) return true;
                if (isValueTypeDollars && !isLast && totalSumExceedsRate) return true;
                if (isLast && stage.value.eq(0)) return true;
                if (stage.value.eq(0)) return true;
                return false;
            });
        }
        return false;
    }
    stagesWithFinalAmount(cost) {
        const discountedPrice = serviceCostModel.applyDiscount(cost);
        const price = serviceCostModel.price(cost);
        const isPercentage = this.data.valueType === "percent";
        const stages = this.data.stages.map((stage)=>_object_spread_props(_object_spread({}, stage), {
                discountedFinalAmount: isPercentage ? discountedPrice.mul(stage.value).div(100).toDP(2) : stage.value.mul(discountedPrice).div(price).toDP(2),
                finalAmount: isPercentage ? price.mul(stage.value).div(100).toDP(2) : stage.value
            }));
        if (isPercentage) {
            stages[stages.length - 1].discountedFinalAmount = stages.slice(0, -1).reduce((acc, curr)=>acc.minus(curr.discountedFinalAmount), discountedPrice);
            stages[stages.length - 1].finalAmount = stages.slice(0, -1).reduce((acc, curr)=>acc.minus(curr.finalAmount), price);
        }
        return stages;
    }
    terms() {
        return this.data.terms;
    }
    valueType() {
        return this.data.valueType;
    }
    isAutoFirst() {
        return this.data.terms === "auto_first";
    }
    stages() {
        return this.data.stages;
    }
    setTerms(terms) {
        return new OneTimeInStagesModel(_object_spread_props(_object_spread({}, this.data), {
            terms
        }));
    }
    setStages(stages) {
        return new OneTimeInStagesModel(_object_spread_props(_object_spread({}, this.data), {
            stages
        }));
    }
    setValueType(valueType) {
        return new OneTimeInStagesModel(_object_spread_props(_object_spread({}, this.data), {
            valueType
        }));
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
